module.exports = __webpack_public_path__ + "media/images/icons/vods-count-348eaaf81ea08c38eff1f5eff293ea7f.svg";